class StatusMotoristaEnum {
  constructor() {
    this.EM_TRANSITO = 1;
    this.NA_FILA = 3;
    this.ENTREGUE = 5;
    this.DESISTIU = 6;
    this.EMBARCADO = 7;
    this.REMOVIDO = 8;
    this.AGUARDANDO_APROVACAO = 10;
  }

  getTiposLabel() {
    return [
      {
        label: 'Em trânsito',
        value: this.EM_TRANSITO,
        background: '#F9F0FF',
        textColor: '#531DAB',
      },
      {
        label: 'Na fila',
        value: this.NA_FILA,
        background: '#FFFBE6',
        textColor: '#AD6800',
      },
      {
        label: 'Embarcado',
        value: this.EMBARCADO,
        background: '#E6F7FF',
        textColor: '#1890FF',
      },
      {
        label: 'Removido',
        value: this.REMOVIDO,
        background: '#F5F5F5',
        textColor: '#595959',
      },
      {
        label: 'Desistiu',
        value: this.DESISTIU,
        background: '#FFF1F0',
        textColor: '#CF1322',
      },
      {
        label: 'Aguardando aprovação',
        value: this.AGUARDANDO_APROVACAO,
        background: '#FFF2EE',
        textColor: '##8A5E50',
      },
      {
        label: 'Entregue',
        value: this.ENTREGUE,
        background: '#EEFFF6',
        textColor: '#128945',
      },
    ];
  }

  getTipo(direcionamento) {
    return this.getTiposLabel()
      .filter(label => label.value === direcionamento)
      .shift();
  }
}

export default new StatusMotoristaEnum();
